// src/utils/ids.js
const base36 = (n) => Math.abs(n).toString(36).toUpperCase().padStart(3, '0');

// Tiny ~1km token from lat/lng (swap for geohash later if desired)
export function geo5(lat, lng) {
  const q = (v, step) => Math.round((v ?? 0) / step) * step;
  const latQ = q(lat, 0.01);
  const lngQ = q(lng, 0.01);
  return Buffer.from(`${latQ.toFixed(2)},${lngQ.toFixed(2)}`)
    .toString('base64')
    .replace(/[^A-Z0-9]/gi, '')
    .slice(0, 5)
    .toUpperCase();
}

export function makeIncidentId(city, lat, lng, ts = Date.now()) {
  const citySlug = String(city || 'CITY')
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, 8);
  const d = new Date(ts);
  const day = `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}${String(
    d.getDate()
  ).padStart(2, '0')}`;
  const g5 = geo5(lat, lng);
  const short = base36(ts % 46656); // 36^3 range
  return `${citySlug}-${day}-${g5}-${short}`;
}
